import { render } from "./BrandLogo.vue?vue&type=template&id=b2a6fe62&ts=true"
import script from "./BrandLogo.vue?vue&type=script&lang=ts"
export * from "./BrandLogo.vue?vue&type=script&lang=ts"

import exportComponent from "/home/cretzler/source/Contributr-v2/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__